import { useRoutes, Navigate } from "react-router-dom";
import Dashboard from "../../modules/Fixiter/pages/Dashboard";
import Layout from "../../components/Layout";
import Courses from "../../modules/Fixiter/pages/Courses";
import Certificate from "../../modules/Fixiter/pages/Certificate";
import { useOnboard } from "../../hooks/OnboardContext";
import LayoutIframe from "../../components/LayoutIframe";
import Logon from "../../modules/Logon";
import UsersProfile from "../../components/UsersProfile";
import PlanExpired from "../../modules/Fixiter/pages/PlanExpired";

function FixiterRoutes() {
  const { planHasExpired } = useOnboard();

  const expiredRoutes = useRoutes([
    { path: "/", element: <Logon /> },
    {
      path: "/fixiter/dashboard",
      element: (
        <LayoutIframe>
          <PlanExpired />
        </LayoutIframe>
      ),
    },
  ]);

  const fixiterRoutes = useRoutes([
    {
      path: "/fixiter/dashboard",
      element: (
        <Layout>
          <Dashboard />
        </Layout>
      ),
    },
    {
      path: "/fixiter/courses",
      element: (
        <Layout>
          <Courses />
        </Layout>
      ),
    },
    {
      path: "/fixiter/certificate",
      element: (
        <Layout>
          <Certificate />
        </Layout>
      ),
    },
    {
      path: "/fixiter/profile/:options",
      element: (
        <Layout>
          <UsersProfile />
        </Layout>
      ),
    }
  ]);

  if (planHasExpired) {
    return expiredRoutes;
  }

  return fixiterRoutes;
}

export default FixiterRoutes;
